module.exports = __webpack_public_path__ + "static/banner-image-89d0ad67bf57cf8d368b20cfd2f29e6c.png";